export default __webpack_public_path__ + "content/media/27.b103cfa9.jpg";